module.exports = __webpack_public_path__ + "0c781646be8c3a9bc8034589cf5ba567.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/data-smart/images/illustrations_04.png
// module id = 934
// module chunks = 3